import { getAPIURL, toV3URL, toMapperURL } from './utils.js';

export const getAppURLs = (path) => {
  return {
    termBrowser: toV3URL(path),
    mapper: toMapperURL(path),
  };
};

// app: 'termBrowserV2' | 'termBrowser' | 'mapper' | 'api'
//
// Every OCL app (oclweb2/3, oclmap) exposes a /signin route
// (SigninRedirect) that starts its own OIDC flow. When our visitor is
// signed in, linking there makes the shared Keycloak session sign them
// into the target app silently — they arrive already authenticated.
export const appLink = (app, path='/') => {
  if (app === 'api')
    return getAPIURL();
  return getAppURLs(path)[app];
};
